import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Station } from '@/types/station'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchStation(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Station>, any> {
  return useQuery(
    [queryKeys.stations, interfaceId, searchParams],
    async () => {
      if (!!interfaceId) {
        const { data } = await stationDataConfigApi.getAll({
          ...searchParams,
          interfaceId,
        })

        if (!data) return null

        const stationList =
          data.data.length > 0 &&
          data?.data.map((item: any) => {
            return {
              id: item.id,
              controller: item.controller,
              decoderType: item.decoderType,
              state: item.state,
              plant: item.plant,
              emitter: item.emitter,
              etRuntime: item.etRuntime,
              interfaceId: item.interfaceId,
              soil: item.soil,
              errorName: item.errorName,
              errorCode: item.errorCode,
              defaultRunTime: item.defaultRunTime,
              precipitationRate: item.precipitationRate,
              pipe: item.pipe,
              etZone: item.etZone,
              surfaceAccumulation: item.surfaceAccumulation,
              plantAvailWater: item.plantAvailWater,
              expectedFlow: item.expectedFlow,
              observedFlow: item.observedFlow,
              landscapeFactor: item.landscapeFactor,
              rtDayOverride: item.rtDayOverride,
              waterRequired: item.waterRequired,
              type: item.type,
              address: item.address,
              index: item.index,
              subArea: item.subArea,
              areaId: item.areaId,
            }
          })

        return {
          list: stationList,
          page: data.page,
          size: data.size,
          sort: data.sort,
          totalCount: data.totalCount,
          totalPage: data.totalPage,
        }
      }
    },
    queryOptions,
  )
}

export default useSearchStation
